import './index.scss';

class LogoGridList {
    constructor(root) {
        this.root = root;

        this.logos = Array.from(this.root.querySelectorAll('.logogrid-item-logo'));
        this.panes = Array.from(this.root.querySelectorAll('.logogrid-item-pane'));

        this.logos.forEach((logo) => {
            logo.addEventListener('click', () => {
                if (logo.classList.contains('opened')) {
                    this.hidePane(logo.dataset.itemId);
                } else {
                    this.showPane(logo.dataset.itemId);
                }
            });
        });

        this.count = 0;
        this.rearrange();

        this.panes.forEach((pane) => { pane.style.display = 'block'; });

        window.addEventListener('resize', this.resize.bind(this));
    }

    hidePane(itemId) {
        this.logos.forEach((logo) => {
            if (logo.dataset.itemId === itemId) {
                logo.classList.remove('opened');
            }
        });

        this.panes.forEach((pane) => {
            if (pane.dataset.itemId === itemId) {
                pane.classList.remove('opened');
                pane.style.maxHeight = null;
            }
        });
    }

    showPane(itemId) {
        let opened = false;

        this.logos.forEach((logo) => {
            if (logo.classList.contains('opened')) {
                logo.classList.remove('opened');
                opened = true;
            }
        });

        this.panes.forEach((pane) => {
            if (pane.classList.contains('opened')) {
                pane.classList.remove('opened');
                pane.style.maxHeight = null;
            }
        });

        setTimeout(() => {
            let logo = this.root.querySelector('.logogrid-item-logo[data-item-id="' + itemId + '"]');
            if (logo) {
                logo.classList.add('opened');
            }

            let pane = this.root.querySelector('.logogrid-item-pane[data-item-id="' + itemId + '"]');
            if (pane) {
                pane.classList.add('opened');
                pane.style.maxHeight = pane.scrollHeight + 'px';
            }
        }, opened ? 300 : 5);
    }

    resize() {
        this.rearrange();

        this.panes.forEach((pane) => {
            if (pane.classList.contains('opened')) {
                pane.style.maxHeight = pane.scrollHeight + 'px';
            }
        });
    }

    rearrange() {
        if (this.count === this.getCount()) { return; }

        this.count = this.getCount();

        let logos = Array.from(this.logos);
        let panes = Array.from(this.panes);
        let list = [];

        while (logos.length && panes.length) {
            for (let i = 0; i < this.count && logos.length; i++) { list.push(logos.shift()); }
            for (let i = 0; i < this.count && panes.length; i++) { list.push(panes.shift()); }
        }

        let order = 0;
        list.forEach((item) => { item.style.order = order++; });
    }

    getCount() {
        let count = 2;

        if (window.innerWidth >= 480) { count = 3; }
        if (window.innerWidth >= 768) { count = 5; }

        return count;
    }
}

window.app.run(() => {
    document.querySelectorAll('.logogrid-list').forEach((node) => {
        new LogoGridList(node);
    });
});
